import { getStepStructureForSlug } from '@/utils/insuranceStepBack';
import { isTpvcaMandatorySlug, isUnregisteredTpvcaSlug } from '@/utils/tpvcaInsurance';
import { isKaskoInsuranceSlug } from '@/utils/kaskoInsurance';
import { isPavezejoInsuranceSlug } from '@/utils/calculatorProductSlugs';

/** First internal step that needs completed offers (TA for TPVCA / pavežėjas, personal for Kasko). */
export function getVehicleFlowProtectedFromStep(slug) {
  if (isKaskoInsuranceSlug(slug)) return 5;
  if (isTpvcaMandatorySlug(slug) || isPavezejoInsuranceSlug(slug)) return 5;
  return null;
}

export function hasVehicleFlowStep0Prerequisites(formData, slug) {
  if (!formData || typeof formData !== 'object') return false;

  const code = String(formData.code || '').trim();
  if (!code) return false;
  if (!formData.startDate) return false;

  if (isUnregisteredTpvcaSlug(slug)) {
    const vin = String(
      formData.vin || formData.vehicleInfo?.vin || ''
    ).trim();
    return vin.length >= 17;
  }

  return Boolean(String(formData.plate || '').trim());
}

export function hasVehicleFlowOffersPrerequisites(formData) {
  const quote = formData?.completedQuoteResponse;
  if (!quote || typeof quote !== 'object') return false;

  const results = quote.results;
  const hasResults = Array.isArray(results) && results.length > 0;
  if (quote.status === 'failed' && !hasResults) return false;

  return Boolean(formData?.selectedOffer) || hasResults;
}

export function isTransportPayerLeasing(formData) {
  return formData?.kaskoPayerCategory === 'leasing_company';
}

/** Mokėtojas = draudėjas (savininkas) — vieni laukai žemiau, be dubliavimo. */
export function isTransportPayerOwner(formData) {
  return formData?.kaskoPayerCategory === 'owner';
}

export function isTransportPayerOther(formData) {
  return formData?.kaskoPayerCategory === 'other';
}

export function isKaskoBeneficiaryOther(formData) {
  return formData?.kaskoBeneficiaryCategory === 'other';
}

/**
 * When user opens a late step (?s=6) without prior data, send them back to step 0.
 * Returns redirect internal step index or null if access is allowed.
 */
export function getVehicleFlowRedirectStep(formData, slug, targetStep) {
  const protectedFrom = getVehicleFlowProtectedFromStep(slug);
  if (protectedFrom == null || targetStep < protectedFrom) return null;

  const structure = getStepStructureForSlug(slug);
  if (targetStep > structure.summaryStep) return null;

  if (!hasVehicleFlowStep0Prerequisites(formData, slug)) return 0;
  if (!hasVehicleFlowOffersPrerequisites(formData)) return 0;

  return null;
}
